module.exports = __webpack_public_path__ + "img/152.e666c40e.jpg";